import { render } from "./CopyDescription.vue?vue&type=template&id=40470a9c"
import script from "./CopyDescription.vue?vue&type=script&lang=js"
export * from "./CopyDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__